module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "utLXLP3TTRKeqiMicsMJgv7"
    }
  }, [_vm._v("Chapter Three")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("The sun cast slivers of light through the glass cupola of the American Museum of Natural History. Below the rotunda, Jurassic skeletons welcomed the sunrise.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("A chime alerted the night watchman that his shift was over. It also prompted the electric illumination of all halls and galleries throughout the vast labyrinth. Light from halogen lamps flooded the museum revealing the “Star of India”, the world’s largest blue sapphire, the fossilized skeleton of the “Turkana Boy”, a one-point-six-million-year-old specimen of "), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Homo erectus, ")]), _vm._v("along with countless other natural and cultural treasures.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("At 10 A.M., a second chime sounded and the day watchman unlocked the massive entrance door. Within minutes, a swarm of seven-year-olds, chaperoned by field trip coordinator Harriet Robbins, poured into the marble-floored lobby shattering the repository’s silent solemnity with giggles and laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Boys and girls, first we are going to visit Triassic Hall. Who can tell me what marked the Triassic Period?” asked Miss Robbins.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Me! Me! Me!” echoed a chorus of young voices.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“OK, Elizabeth, tell the class.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“It comes before the Jurassic Period. It’s when the first dinosaurs were born.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Very good,” said Miss Robbins. She led the pack inside the enormous exhibit hall.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The children, with wide-open eyes, approached a pair of teratosaurus skeletons.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Our first meat eaters,” Miss Robbins said.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Matthew, the know-it-all, strayed from the group, hoping to find a critter he had not yet encountered on his dinosaur CD-ROM. He drew near a towering montage of bones he knew to be the plateosaurus but what he saw between its legs didn’t fit. Maybe Miss Robbins could explain. He rejoined his classmates and tugged on the teacher’s skirt.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Matthew, do you need to go to the boy’s room?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No, Miss Robbins.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Then what is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Isn’t the plateosaurus a plant eater?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Of course it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The boy pointed his finger at the assemblage of bones.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Then how come that one’s got a dead lady coming out of its butt?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aecfad3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SR_003.vue
// module id = 84
// module chunks = 0